import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, Container, Btn } from "@/components/kit";
import { useAuth, formatApiErrorDetail } from "@/lib/auth";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const label = "t-caption font-mono uppercase tracking-wide text-[var(--muted)]";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(f.email.trim(), f.password);
      nav(u.role === "admin" ? "/admin" : "/account", { replace: true });
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message);
    }
    setBusy(false);
  };

  return (
    <>
      <Seo title="Log in" canonical="/login" description="Log in to your Prox account." />
      <PageHero eyebrow="Account" crumbs={[{ label: "Home", to: "/" }, { label: "Log in" }]} title="Log in." lead="Access your Prox account." />
      <Section bg="bone">
        <Container size="sm" className="!px-0">
          <form onSubmit={submit} className="space-y-6 max-w-md" data-testid="login-form">
            <label className="block"><span className={label}>Email</span>
              <input type="email" className="field mt-2" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="login-email" autoComplete="email" /></label>
            <label className="block"><span className={label}>Password</span>
              <input type="password" className="field mt-2" value={f.password} onChange={(e) => set("password", e.target.value)} data-testid="login-password" autoComplete="current-password" /></label>
            {err && <p className="t-sm text-[#a24f3a]" data-testid="login-error">{err}</p>}
            <Btn type="submit" variant="clay" className="w-full justify-center" data-testid="login-submit">{busy ? "Signing in\u2026" : "Log in"}</Btn>
            <p className="t-sm text-[var(--muted)]">No account yet? <Link to="/register" className="lnk">Create one</Link>.</p>
          </form>
        </Container>
      </Section>
    </>
  );
}
